<template>
  <b-modal id="map" centered size="xl" class="travel-map" hide-footer
    title="I’ve got itchy feet and a growing list of places to explore—hopefully this map will soon be full of red pins.">
    <div class="map">
      <GmapMap class="google_map" :center="{ lat: 10, lng: 106 }" :zoom="3" map-type-id="terrain" style="height: 500px">
        <GmapMarker :key="index" v-for="(m, index) in markers" :position="m" :clickable="true" :draggable="true"
          @click="center = m" />
      </GmapMap>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      markers: [
        { lat: 10.7758439, lng: 106.7017555 },
        { lat: 19.8887438, lng: 102.135898 },
        { lat: 13.3617562, lng: 103.8590321 },
        { lat: 13.7538929, lng: 100.8160803 },
        { lat: 1.357107, lng: 103.8194992 },
        { lat: 17.05943415, lng: 96.11338955 },
        { lat: 3.1516964, lng: 101.6942371 },
        { lat: 11.1800079, lng: 119.3904846 },
        { lat: -8.23565805, lng: 115.1223866 },
        { lat: 25.0375198, lng: 121.5636796 },
        { lat: 6.9349969, lng: 79.8538463 },
        { lat: 35.6828387, lng: 139.7594549 },
        { lat: 37.5666791, lng: 126.9782914 },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
@import '../styles/components/TravelMap.scss'
</style>
